import * as classes from "./plant-power-meter.module.scss";
import content from "../../content.json";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";

const PlantPowerMeter = () => {
  const { state } = useContext(AppContext);
  const { plantPower } = state;
  const [percentage, setPercentage] = useState<string>(
    plantPower.previous.toLocaleString("en", {
      style: "percent",
    })
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPercentage(
        plantPower.current.toLocaleString("en", { style: "percent" })
      );
    }, 555);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={classes.root}>
      <span className={classes.heading}>Your Collection </span>
      <span style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}>
        {percentage}
      </span>
      <div aria-hidden="true" className={classes["meter-outer"]}>
        <div
          className={classes["meter-inner"]}
          style={{ width: percentage }}
        ></div>
        <div className={classes["meter-notch"]}></div>
        {Object.keys(content.rarePlants).map((key) => (
          <div className={classes["meter-notch"]} key={key}></div>
        ))}
      </div>
    </div>
  );
};

export default PlantPowerMeter;
